import React from "react";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import AllocationList from "./AllocationList";

const Reserves = () => {
  return (
    <AllocationList
      status="DRAFT"
      title="Reserves"
      description="Review and open saved production allocation drafts before they are finally allotted."
      icon={
        <BookmarkBorderOutlinedIcon
          sx={{
            fontSize: 27,
            color: "#b54708",
          }}
        />
      }
      basePath="/reserves"
    />
  );
};

export default Reserves;
